'use client';
import dynamic from 'next/dynamic';

const PolicyPDFViewer = dynamic(() => import('@/components/PolicyPDFViewer'), {
  ssr: false,
});

export default function Page() {
  return (
    <PolicyPDFViewer
      fileUrl="https://triotech-website.famapp.co.in/Customer_Grievance_Redressal_Policy.pdf"
      languageSwitch={{
        href: '/grievance/hindi/',
        label: 'Want to view this in Hindi? Click here',
      }}
    />
  );
}
